import React from "react";
import { Card, Table, Tag, Empty } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { ActivityLogEntry } from "../../../Api";

interface ActivityLogProps {
  logs: ActivityLogEntry[];
  loading: boolean;
}

const columns = [
  {
    title: "Time",
    dataIndex: "timestamp",
    key: "timestamp",
    width: 140,
    render: (val: string) => (
      <span className="text-xs text-gray-400 font-mono">
        {new Date(val).toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })}
      </span>
    ),
  },
  {
    title: "From",
    dataIndex: "from",
    key: "from",
    width: 160,
    render: (val: string) => (
      <span className="text-xs font-mono text-gray-600">
        {val.replace("@c.us", "")}
      </span>
    ),
  },
  {
    title: "Message",
    dataIndex: "body",
    key: "body",
    render: (val: string) => (
      <span className="text-sm text-gray-700">{val}</span>
    ),
  },
  {
    title: "Replied",
    dataIndex: "replied",
    key: "replied",
    width: 90,
    render: (val: boolean) =>
      val ? (
        <Tag color="success" className="text-xs">Yes</Tag>
      ) : (
        <Tag color="default" className="text-xs">Paused</Tag>
      ),
  },
];

export const ActivityLog = ({ logs, loading }: ActivityLogProps) => {
  return (
    <Card
      title={
        <span className="flex items-center gap-2">
          <MessageOutlined className="text-blue-500" />
          Recent Activity
        </span>
      }
      bordered={false}
      className="bg-white rounded-lg border border-gray-200"
    >
      <Table
        dataSource={logs}
        columns={columns}
        rowKey={(r) => `${r.timestamp}-${r.from}`}
        loading={loading}
        size="small"
        pagination={{ pageSize: 10, size: "small" }}
        scroll={{ x: 500 }}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No messages yet"
            />
          ),
        }}
      />
    </Card>
  );
};
